export default __webpack_public_path__ + "static/media/about1.d2576614.jpg";